import backgroundImage from '../../codify-bg.png';

type CanvasProps = {};

export function Canvas({}: CanvasProps) {
  function CodifyLogo() {
    return (
      <div
        style={{
          position: 'fixed',
          top: '20px',
          left: '30px',
          zIndex: 100,
          color: 'white',
          fontSize: '4rem',
          fontWeight: 'bold',
          letterSpacing: '1px',
          fontFamily: 'Instrument Sans',
          pointerEvents: 'auto',
          textShadow: '0px 2px 4px rgba(0,0,0,0.2)',
          mixBlendMode: 'overlay',
          opacity: '0.8',
        }}
      >
        codify
      </div>
    );
  }

  function GlowLayer() {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background:
            'radial-gradient(circle at 50% 50%, rgba(255, 129, 50, 1) 0%, rgba(255, 50, 67, 0.1) 40%, transparent 70%)',
          pointerEvents: 'none',
          zIndex: 0,
          mixBlendMode: 'overlay',
        }}
      />
    );
  }

  function Vignette() {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background:
            'radial-gradient(ellipse at center, transparent 50%, rgba(0,0,0,0.1) 100%)',
          pointerEvents: 'none',
          zIndex: 50,
          mixBlendMode: 'multiply',
        }}
      />
    );
  }

  function AtmosphericFog() {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background:
            'linear-gradient(to bottom, #87CEEB 0%, rgba(135, 206, 235, 0.8) 10%, transparent 100%)',
          pointerEvents: 'none',
          zIndex: 0,
          opacity: 0.3,
        }}
      />
    );
  }

  function CodifyBackground() {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          pointerEvents: 'none',
          zIndex: -1,
        }}
      />
    );
  }

  return (
    <div
      style={{
        overflow: 'hidden',
        display: 'flex',
        height: '100vh',
        width: '100vw',
      }}
    >
      <CodifyLogo />
      <GlowLayer />
      <Vignette />
      <AtmosphericFog />
      <CodifyBackground />
    </div>
  );
}
